export default "__VITE_ASSET__B2$M1v0H__"